import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { ToastContainer } from 'react-toastify';
import Layout from './Layout';
import Header from '../components/Header/Header';
// import Footer from '../components/Footer/Footer';
import FallbackErrorContent from '../components/FallbackErrorContent/FallbackErrorContent';
import { ThemeProvider } from '@mui/material';
import theme from '../theme';
import { Footer } from 'react-component-utils';

function App() {
    return (
        <BrowserRouter>
            <ErrorBoundary FallbackComponent={FallbackErrorContent}>
                <ThemeProvider theme={theme}>
                    <Header />
                    <Layout />
                    <Footer />
                    <ToastContainer />
                </ThemeProvider>
            </ErrorBoundary>
        </BrowserRouter>
    );
}

export default App;
